export const NAV_LINKS = [
  { label: 'Services', id: 'services' },
  { label: 'Plans', id: 'plans' },
  { label: 'Work', id: 'work' },
  { label: 'Showcase', id: 'showcase' },
  { label: 'Why Us', id: 'why-us' },
  { label: 'Contact', id: 'contact' },
];
